import { configureStore } from '@reduxjs/toolkit';
import commentsReducer from './commentLikesSlice';

export const store = configureStore({
  reducer: {
    comments: commentsReducer,
  },
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;